export default {
  Server: null,
  Port: 0,
  Ssl: true,
  Authentication: true,
  Username: null,
  Password: null,
  Sender: null,
};
